import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
// import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

const state = {
  row: null
}
const actions = {
  init: ({ commit, state }, params) => {
    const ctx = {
      data: {
        init: { api: 'M0601SurveyService.initSurveyForm', input: params }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('EDIT', data.init.output)
      })
  },
  doSubmit: ({ commit, state }, row) => {
    console.debug('called M0611SurveySubmission submit')
    return client.postData({ data: { search: { api: 'M0611SurveySubmissionService.doSubmit', input: row } } })
      .then((data) => {
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
